import { __extends } from "tslib";
import { CreateJourneyRequest, CreateJourneyResponse } from "../models/models_0";
import { deserializeAws_restJson1CreateJourneyCommand, serializeAws_restJson1CreateJourneyCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateJourneyCommand = /** @class */ (function (_super) {
    __extends(CreateJourneyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateJourneyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateJourneyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "CreateJourneyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateJourneyRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateJourneyResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateJourneyCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1CreateJourneyCommand(input, context);
    };
    CreateJourneyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1CreateJourneyCommand(output, context);
    };
    return CreateJourneyCommand;
}($Command));
export { CreateJourneyCommand };
//# sourceMappingURL=CreateJourneyCommand.js.map